/**
 * Parse a date string (YYYY-MM-DD) as local date to avoid timezone issues
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {Date} - Date object in local timezone
 */
export const parseBookingDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Format time slot for display (e.g., '17:00' -> '5:00 PM')
 * @param {string} time - Time string in HH:MM format
 * @returns {string} - Formatted time string
 */
export const formatTimeDisplay = (time) => {
  const parts = time.split(':');
  const hour = parseInt(parts[0]);
  const minutes = parts[1] || '00';
  const ampm = hour >= 12 ? 'PM' : 'AM';
  let displayHour = hour;
  if (hour > 12) {
    displayHour = hour - 12;
  } else if (hour === 0) {
    displayHour = 12;
  }
  return `${displayHour}:${minutes} ${ampm}`;
};

/**
 * Check if a date is a valid operating day
 * @param {Date} date - Date to check
 * @returns {boolean} - True if valid operating day
 */
export const isValidOperatingDay = (date) => {
  // All days are now valid (Monday=1 through Sunday=0)
  return true;
};
